var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInitThemeSwitcher = void 0;

var react_1 = require("react");

var admin_core_1 = require("@wheelroom/admin-core");

var theme_switcher_register_1 = require("./theme-switcher-register");

var theme_switcher_reducer_1 = require("./theme-switcher-reducer");

var initial_state_1 = require("./initial-state");

var action_creator_1 = require("./action-creator");

exports.useInitThemeSwitcher = function (themeInfo) {
  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreDispatch = _react_1$useContext.adminCoreDispatch;

  initial_state_1.initialState.themes = themeInfo.themes;
  initial_state_1.initialState.activeThemeId = themeInfo.defaultThemeId;
  initial_state_1.initialState.lastThemeId = initial_state_1.initialState.activeThemeId;

  var _react_1$useReducer = react_1.useReducer(theme_switcher_reducer_1.themeSwitcherReducer, initial_state_1.initialState),
      _react_1$useReducer2 = _slicedToArray(_react_1$useReducer, 2),
      themeSwitcherState = _react_1$useReducer2[0],
      themeSwitcherDispatch = _react_1$useReducer2[1];

  var actions = action_creator_1.actionCreator(themeSwitcherState, themeSwitcherDispatch);
  react_1.useLayoutEffect(function () {
    if (themeInfo.pageThemeId) {
      actions.setTemporaryActiveTheme(themeInfo.pageThemeId);
    } else {
      actions.setLastTheme();
    }
  }, [themeInfo.pageThemeId]);
  react_1.useEffect(function () {
    adminCoreDispatch(theme_switcher_register_1.themeSwitcherRegister);
  }, []);
  react_1.useLayoutEffect(function () {
    adminCoreDispatch({
      type: 'SET_ADMIN_MODULE_STORE',
      moduleId: theme_switcher_register_1.themeSwitcherRegister.moduleId,
      store: {
        actions: actions,
        state: themeSwitcherState,
        dispatch: themeSwitcherDispatch
      }
    });
    adminCoreDispatch({
      type: 'SET_LAST_MODULE_ID',
      moduleId: theme_switcher_register_1.themeSwitcherRegister.moduleId
    });
  }, [themeSwitcherState]);
};